import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import StatsGraph from "../../Components/StatsGraph/StatsGraph";
import StatsInfoBar from "../../Components/StatsInfoBar/StatsInfoBar";
import StatsHeader from "../../Components/StatsHeader/StatsHeader";

import { callAPI } from "../../assets/Js/backendCommunication";
import { immediateToast } from "izitoast-react";
import projectSettings from "../../assets/Js/projectSettings";
import { roleEnum } from "../../assets/Js/roleEnum";

import { getPlainToken } from "../../assets/Js/tokenHandler";
import { useDateFormater } from "../../Hooks/useDateFormater";
import { useWeekFinder } from "../../Hooks/useWeekFinder";
import { withReduxData } from "../../HOC/withReduxData";

import { useRoleHandler } from "../../Hooks/useRoleHandler";
import { useParams } from "react-router";
import { StatsDashboardTable } from "../../Components/StatsDashbaordTable/StatsDashbaordTable";
import { useQuery } from "../../Hooks/useQuery";
import { useUTCLocalConvertor } from "../../Hooks/UTCLocalConvertor";
import { dateFormatEnum } from "../../assets/Js/dateFormatEnum";

function StatsDashboard({ userData }) {
  const [isStatsInfoLoading, setIsStatsInfoLoading] = useState(false);
  const [isStatsGraphLoading, setIsStatsGraphLoading] = useState(false);
  const [userId, setUserId] = useState("");
  const [isRencentJoinnedAthletesLoading, setIsRencentJoinnedAthletesLoading] =
    useState(false);

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [stats, setStats] = useState({});
  const [chartData, setChartData] = useState({});
  const [recentJoinnedAthletes, setRecentJoinnedAthletes] = useState([]);

  const findWeekDates = useWeekFinder();
  const dateFormater = useDateFormater();
  const roleHandler = useRoleHandler();
  const UTCLocal = useUTCLocalConvertor();

  const { athleteId } = useParams();
  const athletename = useQuery().get("athletename");

  useEffect(() => {
    roleHandler({
      forOwner: () => {
        !athleteId && getRecentJoinnedAthletes();
      },
    });
  }, []);

  useEffect(() => {
    handleUserId();
  }, [athleteId, userData]);

  useEffect(() => {
    if (userId) {
      let { weekStartDate, weekSelectedDate, weekEndDate } = findWeekDates(
        new Date()
      );

      let _startDate = dateFormater(weekStartDate);
      let _endDate = dateFormater(weekEndDate);

      setStartDate(_startDate);
      setEndDate(_endDate);

      getGymGraphStats(_startDate, _endDate);
      getGymStats();
    }
  }, [userId]);

  const handleUserId = () => {
    const forAthlete = () => {
      athleteId ? setUserId(athleteId) : setUserId(userData?.Id);
    };
    const forOwner = () => {
      setUserId(userData?.Id);
    };

    roleHandler({ forAthlete, forOwner });
  };

  const handleDateSelection = (selectedDate) => {
    let { weekStartDate, weekSelectedDate, weekEndDate } =
      findWeekDates(selectedDate);

    let _startDate = dateFormater(weekStartDate);
    let _endDate = dateFormater(weekEndDate);

    setStartDate(_startDate);
    setEndDate(_endDate);

    getGymGraphStats(_startDate, _endDate);
  };

  const getGymStats = async () => {
    let url = `${projectSettings.baseUrl}/GymStats/${athleteId || userId}`;

    let header = true;
    let type = "GET";
    let token = getPlainToken();
    let data = null;
    let response = "";

    if (response === "") {
      setIsStatsInfoLoading(true);
    }

    response = await callAPI(url, header, type, data, token);

    if (response) {
      let { data } = response;

      setIsStatsInfoLoading(false);

      if (data.StatusCode === 200) {
        let _stats = athleteId
          ? data?.Result?.AthleteOverAllStats
          : roleHandler({
              forAthlete: () => data?.Result?.AthleteOverAllStats,
              forOwner: () => data?.Result?.GymOverAllStats,
            });

        setStats(_stats);
      } else {
        immediateToast("warning", { message: "Somthing went wrong" });
      }
    }
  };

  const getGymGraphStats = async (weekStartDate, weekEndDate) => {
    let _startDate = UTCLocal({
      type: dateFormatEnum.utc,
      date: weekStartDate,
    });

    let _endDate = UTCLocal({ type: dateFormatEnum.utc, date: weekEndDate });

    let url = `${projectSettings.baseUrl}/GymStats/GraphStats/${
      athleteId || userId
    }?fromDate=${dateFormater(_startDate, true)}&toDate=${dateFormater(
      _endDate,
      true
    )}`;
    let header = true;
    let type = "GET";
    let token = getPlainToken();
    let data = null;
    let response = "";

    if (response === "") {
      setIsStatsGraphLoading(true);
    }

    response = await callAPI(url, header, type, data, token);

    if (response) {
      let { data } = response;

      setIsStatsGraphLoading(false);

      if (data.StatusCode === 200) {
        let _graphData = athleteId
          ? data?.Result?.AthleteGraphStats
          : roleHandler({
              forAthlete: () => data?.Result?.AthleteGraphStats,
              forOwner: () => data?.Result?.GymGraphStats,
            });

        setChartData(_graphData);
      } else {
        immediateToast("warning", { message: "Somthing went wrong" });
      }
    }
  };

  const getRecentJoinnedAthletes = async () => {
    let url = `${projectSettings.baseUrl}/GymStats/RecentJoinedAthletes`;

    let header = true;
    let type = "GET";
    let token = getPlainToken();
    let data = null;
    let response = "";

    if (response === "") {
      setIsRencentJoinnedAthletesLoading(true);
    }

    response = await callAPI(url, header, type, data, token);

    if (response) {
      let { data } = response;

      setIsRencentJoinnedAthletesLoading(false);

      if (data.StatusCode === 200) {
        setRecentJoinnedAthletes(data.Result);
      } else {
        immediateToast("warning", { message: "Somthing went wrong" });
      }
    }
  };

  return (
    <div className="main-panel w-100">
      <div className="content-wrapper">
        <StatsHeader userInfo={userData} paramName={athletename} />

        <div>
          <StatsInfoBar
            statsInfo={stats}
            isLoading={isStatsInfoLoading}
            desiredRole={athleteId ? roleEnum.athlete : userData.Role}
            loggedInUserRole={userData.Role}
          />
        </div>

        <div>
          <StatsGraph
            chartData={chartData}
            startDate={startDate}
            endDate={endDate}
            isLoading={isStatsGraphLoading}
            desiredRole={athleteId ? roleEnum.athlete : userData.Role}
            loggedInUserRole={userData.Role}
            handleDateSelection={handleDateSelection}
          />
        </div>

        <StatsDashboardTable
          paramId={athleteId}
          userId={userId}
          desiredRole={athleteId ? roleEnum.athlete : userData.Role}
          loggedInUserRole={userData.Role}
          tableData={recentJoinnedAthletes}
          isLoading={isRencentJoinnedAthletesLoading}
        />
      </div>
    </div>
  );
}

export default withReduxData(StatsDashboard);

StatsDashboard.propTypes = {
  userData: PropTypes.object,
};
